import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-black/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Let's Create Something Extraordinary</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Ready to elevate your vision? Get in touch with us to discuss your next project.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-stretch">
          <div className="h-full flex flex-col justify-center">
            <div className="bg-gray-900/80 rounded-xl shadow-lg p-8 h-full flex flex-col justify-center">
              <form className="space-y-6 min-h-[400px] flex flex-col justify-center">
                <div>
                  <label className="block text-sm font-medium mb-2">Name</label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 bg-gray-900 rounded-lg focus:ring-2 focus:ring-emerald-400 focus:outline-none"
                    placeholder="Your name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Email</label>
                  <input
                    type="email"
                    className="w-full px-4 py-3 bg-gray-900 rounded-lg focus:ring-2 focus:ring-emerald-400 focus:outline-none"
                    placeholder="your@email.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Message</label>
                  <textarea
                    className="w-full px-4 py-3 bg-gray-900 rounded-lg focus:ring-2 focus:ring-emerald-400 focus:outline-none h-32"
                    placeholder="Tell us about your project"
                  ></textarea>
                </div>
                <button className="w-full px-8 py-3 bg-emerald-400 text-black font-semibold rounded-lg hover:bg-emerald-300 transition-colors">
                  Send Message
                </button>
              </form>
            </div>
          </div>

          <div className="h-full flex flex-col justify-center">
            <div className="bg-gray-900/80 rounded-xl shadow-lg p-8 h-full flex flex-col justify-center space-y-8">
              <div>
                <h3 className="text-xl font-bold mb-4">Contact Information</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <Mail className="h-5 w-5 text-emerald-400 mr-3" />
                    <span>info@advanceelegancestudio.com</span>
                  </div>
                  <div className="flex items-center">
                    <Phone className="h-5 w-5 text-emerald-400 mr-3" />
                    <span>+92 3001482898</span>
                  </div>
                  <div className="flex items-center">
                    <MapPin className="h-5 w-5 text-emerald-400 mr-3" />
                    <span>Office # 08 Rana Town University Road opposite Fatima Hospital Sargodha, 40100 Pakistan</span>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-4">Business Hours</h3>
                <p className="text-gray-400">
                  Monday - Friday: 9:00 AM - 6:00 PM<br />
                  Saturday: By appointment only<br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;